import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { UrlInputFieldWUT } from '../../../ui/url-input-field';
export const DextUrlInputWUT = (props)=>{
    const fieldType = FIELD_TYPES.DEXT_URL_INPUT;
    return /*#__PURE__*/ React.createElement(UrlInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=dext-url-input-wut.js.map